module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "options-road-map"
  }, [_c('li', [_c('div', {
    staticClass: "circle",
    class: {
      'full': _vm.step > 0
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(0)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 0
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Setup mode")]), _c('br'), (_vm.mode && _vm.step > 0) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(0)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.mode)))]) : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])])]), _c('li', [_c('div', {
    staticClass: "circle",
    class: {
      'full': _vm.step > 1,
      'not-clickable': _vm.step <= 1
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(1)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 1
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Mining hardware")]), _c('br'), (_vm.miningType && _vm.step > 1) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(1)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.miningType)))]) : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])])]), (!(_vm.miningType === 'cpu' && _vm.step > 2)) ? _c('li', [_c('div', {
    staticClass: "circle hint--right",
    class: {
      'full': _vm.step > 2,
      'disabled': _vm.miningType === 'cpu' && _vm.step > 2,
      'not-clickable': _vm.step <= 2
    },
    attrs: {
      "aria-label": "Not needed on cpu mining"
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(2)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 2,
      'disabled': _vm.miningType === 'cpu' && _vm.step > 2
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Algorithm")]), _c('br'), (_vm.algorithm && _vm.algorithm.name && _vm.step > 2) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(2)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.algorithm.name)))]) : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])])]) : _vm._e(), _c('li', [_c('div', {
    staticClass: "circle",
    class: {
      'full': _vm.step > 3,
      'not-clickable': _vm.step <= 3
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(3)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 3
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Coin")]), _c('br'), (_vm.coin && _vm.coin.symbol && _vm.step > 3) ? _c('a', {
    staticClass: "coin-selected",
    on: {
      "click": function($event) {
        return _vm.jumpToStep(3)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("uppercase")(_vm.coin.symbol)))]), _c('img', {
    staticClass: "coin-logo",
    attrs: {
      "src": _vm.coin.logo,
      "alt": _vm.coin.symbol + ' logo'
    }
  })]) : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])])]), _c('li', [_c('div', {
    staticClass: "circle",
    class: {
      'full': _vm.step > 4,
      'not-clickable': _vm.step <= 4
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(4)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 4
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Address")]), _c('br'), (_vm.address && _vm.step > 4) ? [_c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.trimmedAddress))])] : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])], 2)]), (!(_vm.mode === 'basic' && _vm.step > 0)) ? _c('li', [_c('div', {
    staticClass: "circle hint--right",
    class: {
      'full': _vm.step > 5,
      'disabled': _vm.mode === 'basic' && _vm.step > 0,
      'not-clickable': _vm.step <= 5
    },
    attrs: {
      "aria-label": "Not needed on basic mode"
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(5)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 5,
      'disabled': _vm.mode === 'basic' && _vm.step > 0
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Region")]), _c('br'), (_vm.region && _vm.region.description && _vm.step > 5) ? _c('a', {
    staticClass: "region-container",
    on: {
      "click": function($event) {
        return _vm.jumpToStep(5)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("uppercase")(_vm.region.description)))]), (_vm.region.country) ? _c('img', {
    staticClass: "region-image",
    attrs: {
      "src": '/img/region/' + _vm.region.country + '.png'
    }
  }) : _vm._e()]) : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])])]) : _vm._e(), (!(_vm.mode === 'basic' && _vm.step > 0)) ? _c('li', [_c('div', {
    staticClass: "circle hint--right",
    class: {
      'full': _vm.step > 6,
      'disabled': _vm.mode === 'basic' && _vm.step > 0,
      'not-clickable': _vm.step <= 6
    },
    attrs: {
      "aria-label": "Not needed on basic mode"
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(6)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 6,
      'disabled': _vm.mode === 'basic' && _vm.step > 0
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Port")]), _c('br'), (_vm.port && _vm.port.number && _vm.step > 6) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(6)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm.port.number)))]) : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])])]) : _vm._e(), (!(_vm.mode === 'basic' && _vm.step > 0)) ? _c('li', [_c('div', {
    staticClass: "circle hint--right",
    class: {
      'full': _vm.step > 7,
      'disabled': _vm.mode === 'basic' && _vm.step > 0,
      'not-clickable': _vm.step <= 7
    },
    attrs: {
      "aria-label": "Not needed on basic mode"
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(7)
      }
    }
  }), _c('div', {
    staticClass: "stick",
    class: {
      'full': _vm.step > 7,
      'disabled': _vm.mode === 'basic' && _vm.step > 0
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Worker")]), _c('br'), (_vm.worker && _vm.step > 7) ? [(_vm.worker.length > 15) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(7)
      }
    }
  }, [_vm._v(_vm._s(_vm.worker.substring(0, 15) + '...'))]) : _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(7)
      }
    }
  }, [_vm._v(_vm._s(_vm.worker))])] : _c('span', {
    staticClass: "not-selected"
  }, [_vm._v("-")])], 2)]) : _vm._e(), _c('li', [_c('div', {
    staticClass: "circle",
    class: {
      'full': _vm.step > 8,
      'not-clickable': _vm.step <= 8
    },
    on: {
      "click": function($event) {
        return _vm.jumpToStep(8)
      }
    }
  }), _c('div', {
    staticClass: "option-value"
  }, [_c('span', {
    staticClass: "option-title"
  }, [_vm._v("Referral")]), _c('br'), (_vm.referralCode && _vm.step > 8) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.jumpToStep(8)
      }
    }
  }, [_vm._v(_vm._s(_vm.referralCode))]) : _c('span', {
    staticClass: "not-selected cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.jumpToStep(8)
      }
    }
  }, [_vm._v("-")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35a4446a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_road_map.vue
// module id = 370
// module chunks = 1